import { StoreActionType as Type } from "../../types";
const initialState: any = {
  isDarkMode: localStorage.getItem("isDarkMode") === "true" ? true : false 
};

export const darkModeReducer: any = (state: any = initialState, action: any) => {
   switch (action?.type) {
    case Type.SET_DARK_MODE:
      return {
        ...state,
        isDarkMode: action?.payload?.isDarkMode,
      };

    default:
      return state;
  }
};
